import template from './backups.html';
import controller from './backups.controller';
import './backups.scss';

let BackupsComponent = {
  bindings: {
    backups: '<'
  },
  template,
  controller
};

export default BackupsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/backups/backups.component.js